var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    fillOpacity: 0.5,
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path2",
    fillOpacity: 0.8,
    d: "M0 0h6v50H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "svg-path3",
    d: "M24.765 18.794c-.589 0-.97.412-.97.941 0 .53.381.97.94.97h.03c.588 0 .97-.44.97-.97-.03-.5-.382-.94-.97-.94zM24.029 22.235h1.5v8.206h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svg-path4",
    d: "M24.765 15C19.382 15 15 19.382 15 24.765c0 5.382 4.382 9.764 9.765 9.764 5.382 0 9.764-4.382 9.764-9.764 0-5.383-4.382-9.765-9.764-9.765zm0 18.059c-4.589 0-8.294-3.735-8.294-8.294 0-4.56 3.705-8.294 8.294-8.294a8.285 8.285 0 0 1 8.294 8.294 8.285 8.285 0 0 1-8.294 8.294z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b9105144984f2ad701786be0da8486f9.svg";
export { ForwardRef as ReactComponent };